import dayjs from "dayjs";
import Popup from "@edusogno/composites/popup.js";
import Content from "./Content";
import isoWeek from "dayjs/plugin/isoWeek";
import weekOfYear from "dayjs/plugin/weekOfYear";
import PopupHeader from "@edusogno/composites/popup-header.js";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { t } from "i18next";

dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);

const SpeakingClassPopup = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  // const [open, setOpen] = useState(false);

  return (
    <Popup
      open={open}
      onOpenChange={onClose}
      contentClass="max-w-fit [&>div:nth-child(even)]:flex-[1_1_100%] [&>div:nth-child(even)]:p-0 !flex flex-col w-fit h-fit"
      renderHeader={
        <PopupHeader
          heading={t("btns.speaking_class_modal")}
          className="!px-6"
        />
      }
    >
      <Content onClose={onClose} />
      {/* <Content onClose={() => setOpen(false)} /> */}
    </Popup>
  );
};

export default SpeakingClassPopup;
// export default memo(SpeakingClassPopup);
